<section cdkDropListGroup id="schedule-rotation" [formGroup]="shiftForm" #scheduleManagmentContainer cdk-scrollable>
  <div class="weeks-container">
    <div class='week-header'>
      <div class='source-title'><span class="count">{{weeksData?.length ||
        0}}</span> {{ (weeksData?.length > 1 ? 'serviceSchedule.weeksRecurring' : 'serviceSchedule.weekRecurring') | translate}}</div>
      <div (click)="addWeek()" class='cancel'>{{ 'scheduleRotation.addWeek'| translate}} <span class="plus">+</span>
      </div>
    </div>
    <div *ngIf="weeksData?.length > 0">
      <mat-expansion-panel *ngFor="let shiftForm of shiftsArray.controls;let weekNum = index" formArrayName="shifts"
        class="mat-elevation-z2" (opened)="weeksPanelStatus[weekNum] = true"
        (closed)="weeksPanelStatus[weekNum] = false" [expanded]='weeksPanelStatus[weekNum]'>
        <mat-expansion-panel-header>
          <span class="week-num">{{ 'serviceSchedule.week' | translate}} {{weekNum + 1}}</span>
        </mat-expansion-panel-header>
        <div class="weeks">
          <div class="weeks-controls">
            <div class="shift-select">
              <div class="form-field">
                <mat-form-field appearance="outline" [formGroup]="shiftForm">
                  <mat-select disableOptionCentering formControlName="shiftId">
                    <mat-option [value]="'all'">{{ 'scheduleRotation.allShifts' | translate }}</mat-option>
                    <mat-option [value]='obj.shiftId' *ngFor="let obj of weeksData[weekNum][weekDays[0].day]">
                      {{ obj.shiftName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div title="{{ 'scheduleRotation.deleteTheScheduleRotationWeek' | translate }}" class="mr delete-week">
              <asp-icon (click)="onDelete(weekNum)" color='rgba(14,19,25,0.8)' height='1rem'
                name="ic-20-utility-delete-trash.svg" width="1rem"></asp-icon>
            </div>
          </div>
          <app-splitter [config]="'horizontal 100% 0 0'"></app-splitter>
          <div class="days">
            <div class="row day-box">
              <div *ngFor="let item of weekDays;let x=index;" class="day">
                <div class='header'>
                  <div class='title'>
                    <div class='sub-title' [ngClass]="item.isClosed ? 'sub-title-closed':'sub-title'">{{getTranslation(item.day | titlecase)| uppercase}}</div>
                  </div>
                </div>
                <div class="day-container">
                  <div *ngFor="let shift of shiftsToShow[weekNum]; let i = index" class="single-day">
                    <div class='text' *ngIf="!item.isClosed">
                      {{shift.shiftName | uppercase}}
                    </div>
                    <div class='text-closed' *ngIf="item.isClosed">{{('scheduleRotation.closed'| translate) | uppercase}}</div>
                    <multi-drag-drop *ngIf="!item.isClosed" (itemsUpdated)="itemsUpdated($event,item.day, weekNum, shift.shiftId)"
                      [emptyText]="emptyText2" [items]="getItems(shift,weekNum,item.day)"
                      (cdkDragStarted)="cdkDragStarted($event)" class="employees">
                      <ng-template let-item>
                        <p style="font-size: 0.8rem; margin-bottom: 0;">
                          <asp-icon cdkDragHandle class="drag-icon" name="ic-20-utility-move.svg" width="1.2rem">
                          </asp-icon>
                          {{item.name}}
                        </p>
                      </ng-template>
                    </multi-drag-drop>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>

  </div>
  <div class="source-list">
    <div class='source-title'> {{subHeading | translate}} <span class="count">({{sourceItems?.length || 0}})</span>
    </div>
    <multi-drag-drop [emptyText]="emptyText1" [items]="sourceItems" [removeItem]=false class='employees'
      (cdkDragStarted)="cdkDragStarted($event)">
      <ng-template let-item>
        <p style="font-size: 0.8rem; margin-bottom: 0;">
          <asp-icon cdkDragHandle class="drag-icon" name="ic-20-utility-move.svg" width="1.2rem">
          </asp-icon>
          {{item.name}}
        </p>
      </ng-template>
    </multi-drag-drop>
  </div>
</section>